import type { Rarity } from '@anidex/shared/economy';
import { DivineFx } from './DivineFx';
import { DivineHalo } from './DivineHalo';
import { DivineWings } from './DivineWings';
import { LegendaryFx } from './LegendaryFx';
import { MythicFx } from './MythicFx';
import { SenitaFx } from './SenitaFx';
import { SenitaHalo } from './SenitaHalo';
import { SenitaWings } from './SenitaWings';

interface PrestigeProps {
  rarity: Rarity;
  idPrefix: string;
  lite: boolean;
  rich: boolean;
}

export function isPrestige(rarity: Rarity) {
  return rarity === 'legendary' || rarity === 'mythic' || rarity === 'divine' || rarity === 'senita';
}

export function PrestigeAura({ rarity, idPrefix, lite }: PrestigeProps) {
  if (rarity === 'legendary') {
    return (
      <>
        <span className="fx__glow fx__glow--legendary" aria-hidden="true" />
        {!lite && (
          <span className="fx__sun-slot" aria-hidden="true">
            <span className="fx__sun-rays" />
            <span className="fx__sun-core" />
          </span>
        )}
      </>
    );
  }

  if (rarity === 'mythic') {
    return <span className="fx__glow fx__glow--mythic" aria-hidden="true" />;
  }

  if (rarity === 'senita') {
    return (
      <>
        <span className="fx__glow fx__glow--senita" aria-hidden="true" />
        {!lite && <SenitaWings idPrefix={idPrefix} />}
        {!lite && <SenitaHalo idPrefix={idPrefix} />}
      </>
    );
  }

  if (rarity === 'divine') {
    return (
      <>
        <span className="fx__glow fx__glow--divine" aria-hidden="true" />
        {!lite && <DivineWings idPrefix={idPrefix} />}
        {!lite && <DivineHalo idPrefix={idPrefix} />}
      </>
    );
  }

  return null;
}

export function PrestigeFx({ rarity, lite, rich }: PrestigeProps) {
  if (rarity === 'legendary') return <LegendaryFx motes={!lite} />;
  if (rarity === 'mythic') return <MythicFx motes={!lite} rich={rich} />;
  if (rarity === 'divine') return <DivineFx motes={!lite} rich={rich} />;
  if (rarity === 'senita') return <SenitaFx motes={!lite} rich={rich} />;
  return null;
}
